import axios from '../../../../shared/axios';

import { AppDispatch } from '../../../../store';

import * as actionTypes from '../constants/global-telecom';

import {
  DeleteGlobalTelecomAccountRequest,
  GetGlobalTelecomAccountRequest,
  GlobalTelecomAccount,
  SaveGlobalTelecomAccountRequest,
} from '../../models';

const getGlobalTelecomAccountStart = () => {
  return {
    type: actionTypes.GLOBAL_TELECOM_GET_GLOBAL_TELECOM_ACCOUNT_START,
  };
};

const getGlobalTelecomAccountSuccess = (data: GlobalTelecomAccount) => {
  return {
    type: actionTypes.GLOBAL_TELECOM_GET_GLOBAL_TELECOM_ACCOUNT_SUCCESS,
    data,
  };
};

const getGlobalTelecomAccountFail = (error: any) => {
  return {
    type: actionTypes.GLOBAL_TELECOM_GET_GLOBAL_TELECOM_ACCOUNT_FAIL,
    error,
  };
};

export const getGlobalTelecomAccount = (params: GetGlobalTelecomAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<GlobalTelecomAccount>((resolve, reject) => {
      dispatch(getGlobalTelecomAccountStart());

      const url = `/global-telecom/get-global-telecom-account`;

      axios
        .get(url, { params })
        .then((response) => {
          dispatch(getGlobalTelecomAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getGlobalTelecomAccountFail(err));
          reject(err);
        });
    });
  };
};

const saveGlobalTelecomAccountStart = () => {
  return {
    type: actionTypes.GLOBAL_TELECOM_SAVE_GLOBAL_TELECOM_ACCOUNT_START,
  };
};

const saveGlobalTelecomAccountSuccess = (data: boolean) => {
  return {
    type: actionTypes.GLOBAL_TELECOM_SAVE_GLOBAL_TELECOM_ACCOUNT_SUCCESS,
    data,
  };
};

const saveGlobalTelecomAccountFail = (error: any) => {
  return {
    type: actionTypes.GLOBAL_TELECOM_SAVE_GLOBAL_TELECOM_ACCOUNT_FAIL,
    error,
  };
};

export const saveGlobalTelecomAccount = (params: SaveGlobalTelecomAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveGlobalTelecomAccountStart());

      const url = `/global-telecom/save-global-telecom-account`;

      axios
        .post(url, params)
        .then((response) => {
          dispatch(saveGlobalTelecomAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveGlobalTelecomAccountFail(err));
          reject(err);
        });
    });
  };
};

const deleteGlobalTelecomAccountStart = () => {
  return {
    type: actionTypes.GLOBAL_TELECOM_DELETE_GLOBAL_TELECOM_ACCOUNT_START,
  };
};

const deleteGlobalTelecomAccountSuccess = (data: boolean) => {
  return {
    type: actionTypes.GLOBAL_TELECOM_DELETE_GLOBAL_TELECOM_ACCOUNT_SUCCESS,
    data,
  };
};

const deleteGlobalTelecomAccountFail = (error: any) => {
  return {
    type: actionTypes.GLOBAL_TELECOM_DELETE_GLOBAL_TELECOM_ACCOUNT_FAIL,
    error,
  };
};

export const deleteGlobalTelecomAccount = (params: DeleteGlobalTelecomAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(deleteGlobalTelecomAccountStart());

      const url = `/global-telecom/delete-global-telecom-account`;

      axios
        .delete(url, { params })
        .then((response) => {
          dispatch(deleteGlobalTelecomAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteGlobalTelecomAccountFail(err));
          reject(err);
        });
    });
  };
};
